module.exports = __webpack_public_path__ + "static/media/M84ws.3c9fd231.pdf";